var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-top-box',{attrs:{"background-image":_vm.registration.program.meta.background,"title1":_vm.registration.program.name,"description":_vm.registration.program.description,"link1":_vm.group,"link2":_vm.date}})
}
var staticRenderFns = []

export { render, staticRenderFns }